import { Link } from "react-router-dom";

const PINK = "hsl(var(--accent))";
const FONT = { fontFamily: "Poppins, sans-serif", fontWeight: 500, letterSpacing: "-0.015em" };
const SIZES = { sm: 17, default: 21, lg: 36 };

const KeyI = ({ color = PINK }) => (
  <svg viewBox="0 0 40 100" aria-hidden="true" className="inline-block"
    style={{ height: "1.04em", width: "0.41em", verticalAlign: "-0.2em", margin: "0 0.005em" }}>
    <circle cx="20" cy="16" r="11.5" fill="none" stroke={color} strokeWidth="9" />
    <rect x="15.5" y="26" width="9" height="72" rx="4.5" fill={color} />
    <rect x="20" y="66" width="14" height="8" rx="2.5" fill={color} />
    <rect x="20" y="80" width="11" height="8" rx="2.5" fill={color} />
  </svg>
);

export function LogoLockup({ size = "default", variant = "dark", tagline = true }) {
  const fs = SIZES[size];
  const text = variant === "light" ? "text-white" : "text-primary";
  return (
    <span className={`inline-flex flex-col items-start leading-none whitespace-nowrap ${text}`} style={{ fontSize: fs }} data-testid="logo-lockup">
      <span style={{ ...FONT, lineHeight: 1 }}>
        bretagne<span style={{ color: PINK, fontSize: "1.45em", lineHeight: 0, marginLeft: "0.04em" }}>.</span>
      </span>
      <span style={{ ...FONT, lineHeight: 1, marginTop: "0.02em" }}>
        conc<KeyI />ergerie
      </span>
      {tagline && (
        <span className="self-stretch text-center uppercase" data-testid="logo-tagline"
          style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500, fontSize: "0.3em", letterSpacing: "0.42em", marginTop: "0.75em", paddingLeft: "0.42em", opacity: 0.95 }}>
          Comparateur
        </span>
      )}
    </span>
  );
}

export default function Logo({ size = "default", variant = "dark" }) {
  return (
    <Link to="/" className="inline-flex group" data-testid="logo-link" aria-label="Bretagne Conciergerie Comparateur">
      <LogoLockup size={size} variant={variant} />
    </Link>
  );
}
